import {
  ROLE_OPERATION_MANAGER,
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_SITE_FINANCIAL_COORDINATOR,
  ROLE_STUDY_MANAGER
} from '../../../../../../../constants/userRoles';

const financeAccessOptionsList = ['financeDetailsAccess', 'remittanceNotification'];

const expensesAccessOption = ['expensesAccess'];

const patientPaymentAccessOption = ['patientPaymentAccess'];

const financeAccessOptions = {
  [ROLE_STUDY_MANAGER]: [...patientPaymentAccessOption, ...expensesAccessOption, ...financeAccessOptionsList],
  [ROLE_PRINCIPAL_INVESTIGATOR]: financeAccessOptionsList,
  [ROLE_OPERATION_MANAGER]: [...expensesAccessOption, ...financeAccessOptionsList],
  [ROLE_SITE_FINANCIAL_COORDINATOR]: financeAccessOptionsList
};

const defaultSelectedFinanceAccess = {
  [ROLE_STUDY_MANAGER]: [...patientPaymentAccessOption]
};

export function getFinanceAccessOptionsForRole(role) {
  return financeAccessOptions[role] || [];
}

export function getDefaultSelectedFinanceAccessForRole(role) {
  return defaultSelectedFinanceAccess[role] || [];
}
